import * as THREE from 'three'
import type { Pose } from './pose'

export type StoredArticleTransform = {
  articleId: string
  instanceIndex: number
  positionX: number
  positionY: number
  positionZ: number
  rotationX: number
  rotationY: number
  rotationZ: number
  rotationW: number
}

const mRot = new THREE.Matrix4()
const mTNeg = new THREE.Matrix4()
const mTPos = new THREE.Matrix4()

export function pivotOffsetMatrix(
  out: THREE.Matrix4,
  pose: Pose,
  pivot: THREE.Vector3,
): THREE.Matrix4 {
  mRot.makeRotationFromQuaternion(pose.quat)
  mTNeg.makeTranslation(-pivot.x, -pivot.y, -pivot.z)
  mTPos.makeTranslation(pivot.x + pose.delta.x, pivot.y + pose.delta.y, pivot.z + pose.delta.z)
  return out.copy(mTPos).multiply(mRot).multiply(mTNeg)
}

export function poseFromStored(t: StoredArticleTransform, pivot: THREE.Vector3): Pose {
  const quat = new THREE.Quaternion(t.rotationX, t.rotationY, t.rotationZ, t.rotationW)
  const delta = new THREE.Vector3(t.positionX, t.positionY, t.positionZ)
    .sub(pivot)
    .add(pivot.clone().applyQuaternion(quat))
  return { delta, quat }
}

export function storedFromPose(
  pose: Pose,
  pivot: THREE.Vector3,
  meta: { articleId: string; index: number },
): StoredArticleTransform {
  const pos = pose.delta.clone().add(pivot).sub(pivot.clone().applyQuaternion(pose.quat))
  return {
    articleId: meta.articleId,
    instanceIndex: meta.index,
    positionX: pos.x,
    positionY: pos.y,
    positionZ: pos.z,
    rotationX: pose.quat.x,
    rotationY: pose.quat.y,
    rotationZ: pose.quat.z,
    rotationW: pose.quat.w,
  }
}
